export default __webpack_public_path__ + "static/media/knight03.cf404c15.jpg";